export const INTERVAL_OPTIONS = ['1H', '6H', '12H', '1D', '1W', '1M'] as const

export const ONE_SECOND_IN_MS = 1000

export const SECOND_INTERVALS = {
	3600: '1H',
	21600: '6H',
	43200: '12H',
	86400: '1D',
	604800: '1W',
	2628000: '1M',
} as const

export type DateInterval = (typeof INTERVAL_OPTIONS)[number]

export function convertIntervalToSeconds(interval: DateInterval): number {
	const entries = Object.entries(SECOND_INTERVALS)
	const findedEntry = entries.find(([_, label]) => interval === label)
	return findedEntry ? parseFloat(findedEntry[0]) : 0
}

export function convertSecondsToExpiryDate(interval: DateInterval): string {
	const seconds = convertIntervalToSeconds(interval)
	const hours = Math.floor(seconds / 3600)
	const minutes = Math.floor((seconds % 3600) / 60)
	const secondsLeft = seconds % 60
	const hoursString = hours.toString().padStart(2, '0')
	const minutesString = minutes.toString().padStart(2, '0')
	const secondsString = secondsLeft.toString().padStart(2, '0')
	return `${hoursString}:${minutesString}:${secondsString}`
}

export function convertSecondsToInterval(seconds: number): DateInterval {
	const entries = Object.entries(SECOND_INTERVALS)
	const findedEntry = entries.find(([secs, _]) => parseFloat(secs) === seconds)
	return findedEntry ? findedEntry[1] : '1D'
}
